import type { IPostCandidatesSearch } from "@api";
import { Typography } from "@mui/material";

interface ICandidateItem {
  candidate: IPostCandidatesSearch["data"][number];
}
export const CandidateItem = ({ candidate }: ICandidateItem) => {
  return (
    <Typography variant="body1" key={candidate.profileId} data-hj-suppress="true">
      {candidate.firstName} {candidate.lastName} (#{candidate.profileId})
    </Typography>
  );
};
